import {
  FormControl,
  FormHelperText,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { CFDI } from "../../../_constants/usoCfdi";
import styles from "../../../styles/global-styles";

const usetSyles = makeStyles((theme) => ({
  label: styles.label,
  customSelect: styles.customSelect,
  table: {
    minWidth: 750,
  },
}));

const UsoCfdiSelect = ({ cfdiValue, option, errorCFDI }) => {
  const classes = usetSyles();
  const [cfdiSelected, setCfdiSelected] = React.useState("");

  useEffect(() => {
    if (option !== "") {
      setCfdiSelected(option);
    } else setCfdiSelected("");
  }, [option]);

  useEffect(() => {
    if (cfdiSelected !== "") {
      cfdiValue(cfdiSelected);
    }
  }, [cfdiSelected]);

  const handleFormInput = ({ target: { value } }) => {
    setCfdiSelected(value);
  };

  return (
    <>
      <FormControl
        variant="outlined"
        className={classes.formControl}
        error={errorCFDI}
      >
        <Typography variant="body2" component={"div"} className={classes.label}>
          Uso CFDI:
        </Typography>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          name="subcategory"
          value={cfdiSelected || ""}
          className={classes.customSelect}
          onChange={(e) => handleFormInput(e)}
        >
          {CFDI.map((item, id) => {
            return (
              <MenuItem key={id} value={item.code || ""}>
                {item.label}
              </MenuItem>
            );
          })}
        </Select>
        {errorCFDI && <FormHelperText>Seleccionar una opcion</FormHelperText>}
      </FormControl>
    </>
  );
};

export default UsoCfdiSelect;
